<template>
  <div>
    <h2>
      {{ $route.meta.title }}
      <v-btn class="float-right" @click="refresh">
        <v-icon v-if="!loading" title="Refresh">mdi-refresh</v-icon>
        <v-icon v-if="loading" title="Loading" disabled>
          mdi-timer-sand
        </v-icon>
      </v-btn>
      <v-btn :to="{ name: 'stack_unit_add' }" class="float-right">
        <v-icon title="New">mdi-plus</v-icon>
      </v-btn>
    </h2>
    <v-data-table
      :page="page"
      :page-count="total_pages"
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      :footer-props="{ itemsPerPageOptions: [] }"
      class="mb-5"
      disable-sort
      @pagination="setQueryPage"
      @click:row="open"
    >
      <template v-slot:item.name="{ item }">
        <router-link
          :to="{
            name: 'stack_unit_form',
            params: { action: 'edit', id: item.id },
          }"
        >
          {{ item.name }}
        </router-link>
      </template>
      <template v-slot:item.shape="{ item }">
        {{ item.shape | capitalize }}
      </template>
      <template v-slot:footer />
    </v-data-table>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'ProductIndex',
  data() {
    return {
      page: 1,
      total: 0,
      total_pages: 0,
      items: [],
      loading: true,
      options: {
        itemsPerPage: 0,
      },
      footer_props: {},
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Prefix', value: 'prefix' },
        { text: 'Description', value: 'description' },
      ],
    }
  },
  //this one will populate new data set when user changes current page.
  watch: {
    options: {
      handler() {
        this.refresh()
      },
    },
    deep: true,
  },
  //this will trigger in the onReady State
  mounted() {
    this.refresh()
  },

  created() {
    if (this.$route.query.page) {
      this.options.page = parseInt(this.$route.query.page)
    }
  },
  methods: {
    //Reading data from API method.
    refresh() {
      this.loading = true
      api
        .get('stack-unit', {
          params: {
            page: this.options.page,
          },
        })
        .then((response) => {
          this.loading = false
          this.items = response.data.data
          this.total = response.data.pager.total
          this.total_pages = response.data.pager.total_pages
          this.options.itemsPerPage = response.data.pager.per_page
        })
    },

    open(item) {
      this.$router.push({
        name: 'stack_unit_form',
        params: { action: 'edit', id: item.id },
      })
    },

    setQueryPage(paginationObject) {
      let path = this.$route.path
      let url =
        paginationObject.page !== 1
          ? path + '?page=' + paginationObject.page
          : path
      if (this.$route.fullPath !== url) {
        this.$router.push(url)
      }
    },
  },
}
</script>
